/* eslint-disable jira/filename-case */
import performance from './performance.tsx';

/*
 * This utility finds all performance entries that is prefixed
 * with the `prefix` and does clearMarks on each entry.
 * All the entries that are cleared will be returned
 */

const clearMarksWithPrefix = (prefix: string): PerformanceEntry[] => {
	if (performance && performance.getEntries && performance.clearMarks) {
		return performance
			.getEntries()
			.filter((mark) => mark.name.startsWith(prefix))
			.map((mark) => {
				performance.clearMarks(mark.name);
				return mark;
			});
	}
	return [];
};

export default clearMarksWithPrefix;
